import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import isEmpty from "lodash/isEmpty";
import ListContacts from "../ListContacts";
import WrapperIonModal from '../../../../Components/ionic/WrapperIonModal';
import CommonSearch from "../../../../Components/CommonSearch";
import i18next from "i18next";

const SendContactsModal = ({isOpen, onClose}) => {
    const {t, i18n} = useTranslation();

    const [contactsList, setContactsList] = useState([]);

    const closeModal = () => {
        if (contactsList?.length) {
            let data = {
                contacts: contactsList
            };
            setContactsList([]);
            onClose && onClose({
                type: "contact",
                data
            });

        } else {
            onClose && onClose(false);
        }
    }


    return <WrapperIonModal
        isOpen={isOpen}
        toggle={closeModal}
        headerComponent={<CommonSearch title={i18next.t('messages.new_message.title', "Choose")}/>}
        >
        <ListContacts state={contactsList} setState={setContactsList} send={closeModal}/>
    </WrapperIonModal>

}

export default SendContactsModal;
